// extracted by mini-css-extract-plugin
export default {"btn":"TrashButton_btn__5+pz0","btnSmall":"TrashButton_btnSmall__xY6I8"};